import React from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import nipponBotApiEndpoints from '../../../services/nipponBotApiEndpoints';

export default function ResumePreviewDialog({ open, resume, onClose, allowDownload = true }) {
  const token = localStorage.getItem('token');
  if (!resume?.id) return null;

  const previewUrl = `${nipponBotApiEndpoints.resumeDownload}/${resume.id}/view?token=${encodeURIComponent(token)}`;
  const downloadUrl = `${nipponBotApiEndpoints.resumeDownload}/${resume.id}/download?token=${encodeURIComponent(token)}`;
  const fileType = resume.fileType || '';
  const isPdf = fileType === 'application/pdf' || /\.pdf$/i.test(resume.originalFileName || '');
  const isImage = fileType.startsWith('image/') || /\.(png|jpe?g|webp)$/i.test(resume.originalFileName || '');

  const handleDownload = () => {
    if (!allowDownload) return;
    window.open(downloadUrl, '_blank');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {resume.originalFileName || 'Resume'}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, minHeight: '70vh', display: 'flex', alignItems: isPdf ? 'stretch' : 'center', justifyContent: 'center' }}>
        {isPdf ? (
          <Box component="iframe" title="Resume Preview" src={previewUrl} sx={{ width: '100%', minHeight: '70vh', border: 'none' }} />
        ) : isImage ? (
          <Box component="img" src={previewUrl} alt="Resume Preview" sx={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', m: 2 }} />
        ) : (
          <Alert severity="info" sx={{ m: 3 }}>
            Preview isn't available for this file type. Please download the resume to view it.
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>Close</Button>
        {allowDownload ? (
          <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleDownload} sx={{ textTransform: 'none' }}>
            Download
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
